// O que falta no cadastro de um cliente para que um documento saia completo. Funções puras.
//
// Clientes criados pela importação de CRLV-e nascem só com nome e CPF/CNPJ, então usá-los num
// documento logo depois é comum. O aviso existe para que ninguém emita sem perceber o que falta.
//
// A separação em dois níveis vem de como cada documento se comporta quando o dado não existe:
//
//  - "buracos": o documento imprime uma linha em branco no lugar (Procuração: "residente no município
//    de ______"; Documentos Complementares: "residente e domiciliado(a) em ______"). É o que
//    realmente estraga o papel.
//  - "omitidos": a frase simplesmente sai sem aquilo, sem marca nenhuma. O documento fica correto,
//    mas mais pobre do que poderia — e quem lê não tem como saber que faltou.
//
// Nome e CPF/CNPJ ficam de fora: as telas já impedem gerar o documento sem eles.

const preenchido = (v) => v != null && String(v).trim() !== '';

// Todas as partes do endereço entram como "buraco": basta faltar uma para a frase sair capenga, e
// faltando todas o documento imprime a linha em branco.
const ENDERECO = [
  ['logradouro', 'logradouro'],
  ['numero', 'número'],
  ['bairro', 'bairro'],
  ['cep', 'CEP'],
  ['cidade', 'cidade'],
  ['uf', 'UF'],
];

// O que cada documento usa e deixa de fora quando falta. Ver a qualificação de cada um:
// Procuração monta "RG: x, telefone: y, e-mail: z"; os Documentos Complementares só citam o RG;
// o contrato (PDF no servidor) imprime FONE e e-mail.
const OMITIDOS_POR_DOCUMENTO = {
  procuracao: [['rg', 'RG'], ['telefone', 'telefone'], ['email', 'e-mail']],
  contrato: [['telefone', 'telefone'], ['email', 'e-mail']],
  documentoComplementar: [['rg', 'RG']],
};

// { buracos: [rótulos], omitidos: [rótulos], completo: bool }
export function pendenciasDoCliente(pessoa, documento) {
  const p = pessoa || {};
  const faltando = (lista) => lista.filter(([campo]) => !preenchido(p[campo])).map(([, rotulo]) => rotulo);
  const buracos = faltando(ENDERECO);
  const omitidos = faltando(OMITIDOS_POR_DOCUMENTO[documento] || []);
  return { buracos, omitidos, completo: buracos.length === 0 && omitidos.length === 0 };
}

// Só as pessoas que têm alguma pendência, já com o rótulo do papel delas no documento
// ("Outorgante", "Vendedor"...). Pessoa ainda não escolhida (sem nome nem CPF) não é cobrada.
export function pendenciasDoDocumento(pessoas, documento) {
  return (pessoas || [])
    .filter(({ pessoa }) => preenchido((pessoa || {}).nome) || preenchido((pessoa || {}).cpfCnpj))
    .map(({ rotulo, pessoa }) => ({ rotulo, pessoa, ...pendenciasDoCliente(pessoa, documento) }))
    .filter((p) => !p.completo);
}
